import * as Sentry from '@sentry/angular-ivy';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from '@environment/environment';

if (environment.production) {
    Sentry.init({
        dsn: 'https://b6ce2cbe7df3e15f6d46708ea852cb33@o59683.ingest.us.sentry.io/4507452570075136',
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/app\.mailfox\.dev/],
        // Performance Monitoring
        tracesSampleRate: 0.3, //  Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    enableProdMode();
    window.console.log = (): void => {};
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
